$(document).ready(function() {
    if($('.homepage-videos .videos-slider').html() != undefined) {

		var advantagesSliderOptions = {
			slidesToShow: 2,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 3000,
						infinite: true,
						arrows: false,
						dots: true,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 3000,
						infinite: true,
						arrows: false,
						dots: true,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 3000,
						arrows: false,
						dots: true,
					}
				},
			]
		};
		var sliderElement = $('.videos-slider');
		sliderElement.slick(advantagesSliderOptions);
    }
});